package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.cards.BookingField
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

// =============================================================================
// FieldTab enum
// =============================================================================

enum class FieldTab(val label: String, val dotColor: Color?) {
    All("All fields", null),
    Field01("Field 01", BookingField.Field01.accentColor),
    Field02("Field 02", BookingField.Field02.accentColor),
    Field03("Field 03", BookingField.Field03.accentColor)
}

// =============================================================================
// FieldSwitcher
// =============================================================================

@Composable
fun FieldSwitcher(
    activeTab: FieldTab,
    onTabSelected: (FieldTab) -> Unit,
    modifier: Modifier = Modifier
) {
    val t = LocalAppStrings.current
    Row(
        modifier
            .sBorderRadius(34)
            .styleModifier {
                property("border", "0.3px solid transparent")
                property("background",
                    "${AppGradients.InteractiveSecondary} padding-box, " +
                    "linear-gradient(0deg, #0A142A, #0A142A) padding-box, " +
                    "${AppGradients.ButtonBorderGradientPrimary} border-box")
                property("padding", "${s(2)} ${s(4)}")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        FieldTab.entries.forEach { tab ->
            val isActive = tab == activeTab
            val tabLabel = when (tab) {
                FieldTab.All -> t.widgetAllFields
                FieldTab.Field01 -> t.widgetFieldLabel("01")
                FieldTab.Field02 -> t.widgetFieldLabel("02")
                FieldTab.Field03 -> t.widgetFieldLabel("03")
            }
            Box(
                Modifier
                    .sBorderRadius(28)
                    .sHeight(if (isActive) 36 else 40)
                    .styleModifier {
                        property("padding", "${s(0)} ${s(26)}")
                        property("cursor", "pointer")
                        property("display", "flex")
                        property("align-items", "center")
                        property("justify-content", "center")
                        property("gap", s(6))
                        property("white-space", "nowrap")
                        if (isActive) {
                            property("background-color", "#0061FF")
                        }
                    }
                    .onClick { onTabSelected(tab) },
                contentAlignment = Alignment.Center
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.styleModifier { property("gap", s(6)) }
                ) {
                    // Colored dot for field tabs
                    tab.dotColor?.let { color ->
                        Box(
                            Modifier
                                .sSize(6)
                                .sBorderRadius(3)
                                .backgroundColor(color)
                        )
                    }
                    SpanText(
                        tabLabel,
                        modifier = Modifier
                            .bodyLMedium()
                            .color(
                                if (isActive) AppColors.PrimaryWhite
                                else Color.hex("BED6F5")
                            )
                    )
                }
            }
        }
    }
}
